import { Component } from "react";

import AccountConfirmation from "../Authentication/AccountConfirmation";

class AccountConfirmationRoute extends Component {
  render() {
    return <AccountConfirmation {...this.props} />;
  }
}

export default AccountConfirmationRoute;
